import React, { useEffect, useState } from "react";
import Card from "components/card";
import ButtonEdit from "../../../../assets/img/icons/ButtonEdit.svg";
import DeleteIcon from "../../../../assets/img/icons/deleteIcon.svg";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table";
import { Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Checkbox } from "@chakra-ui/react";

type RowObj = {
  name: string;
  userName: string;
  email: string;
  action: customFieldType2;
};

type customFieldType2 = {
  id: string;
};

const columnHelper = createColumnHelper<RowObj>();

function ColumnsTableUsers(props: {
  tableData: any;
  handleClickForDeleteModal: (data: any) => void;
  handleClickForDeleteModalMany: (data: any) => void;
  deleteMultiple: any;
  setDeleteMultiple: any;
}) {
  const { tableData, handleClickForDeleteModal } = props;
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const navigate = useNavigate();
  const handleEditClick = (userId: string) => {
    navigate(`../users/userForm/${userId}`);
  };
  const columns = [
    columnHelper.accessor("name", {
      id: " name",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">Name</p>
      ),
      cell: (info: any) => (
        <div className="flex items-center ">
          <Checkbox
            onChange={(e) => {
              if (e.target.checked) {
                props.setDeleteMultiple((prev: any) => [
                  ...prev,
                  info.row.original.userName,
                ]);
              } else {
                props.setDeleteMultiple((prev: any) =>
                  prev.filter((num: any) => num !== info.row.original.userName)
                );
              }
            }}
            isChecked={props.deleteMultiple.includes(
              info.row.original.userName
            )}
            size="lg"
            colorScheme="black"
            className={`mr-3 h-6 w-6 min-w-6 rounded border-2 ${
              props.deleteMultiple.includes(info.row.original.userName)
                ? "border-green-500"
                : "border-mediumseagreen"
            }`}
          />
          <p className="text-sm font-bold text-navy-700 dark:text-white">
            {info.getValue().charAt(0).toUpperCase() + info.getValue().slice(1)}
          </p>
        </div>
      ),
    }),
    columnHelper.accessor("userName", {
      id: "userName",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          Username
        </p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
    columnHelper.accessor("action", {
      id: "action",
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">
          Actions
        </p>
      ),
      cell: (info) => (
        // <p className="text-sm font-bold text-navy-700 dark:text-white">
        //   <img src={eyeview} height={30} width={30} />
        // </p>
        <div className="flex items-center">
          <img
            src={ButtonEdit}
            className="button-edit me-2 cursor-pointer"
            onClick={() => handleEditClick(info.row.original.action.id)}
            height={30}
            width={30}
          />
          <img
            src={DeleteIcon}
            className="button-delete cursor-pointer"
            onClick={() => handleClickForDeleteModal(info.row.original)}
            height={30}
            width={30}
          />
        </div>
      ),
    }),
  ]; // eslint-disable-next-line
  const [data, setData] = React.useState([...tableData]);
  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });
  useEffect(() => {
    setData([...tableData]);
  }, [tableData]);
  const userForm = () => {
    navigate("../users/userForm");
  };
  return (
    <Card extra={"w-full pb-10 p-4 h-full"}>
      <header className="relative flex items-center justify-between">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
          Users
        </div>
        <div>
          <Button
            type="submit"
            className="rounded-md bg-brand-500 p-2 text-white dark:bg-brand-400"
            onClick={userForm}
          >
            Add Users
          </Button>

          {props.deleteMultiple.length > 0 && (
            <>
              {" "}
              <Button
                type="submit"
                className=" mx-5 rounded-md bg-red-700 p-2 text-white dark:bg-brand-400"
                // onClick={handleClickForDeleteModalMany("")}
                onClick={() => handleClickForDeleteModal(props.deleteMultiple)}
              >
                Delete Selected
              </Button>
              <Button
                type="submit"
                className=" mx-5  ml-[-2px] rounded-md bg-brandLinear p-2 text-white dark:bg-brand-400"
                // onClick={handleClickForDeleteModalMany("")}
                onClick={() => props.setDeleteMultiple([])}
              >
                Uncheck All
              </Button>
            </>
          )}
        </div>
      </header>
      <div className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
        <table className="w-full">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id} className="!border-px !border-gray-400">
                {headerGroup.headers.map((header) => {
                  return (
                    <th
                      key={header.id}
                      colSpan={header.colSpan}
                      onClick={header.column.getToggleSortingHandler()}
                      className="cursor-pointer border-b-[1px] border-gray-200 pb-2 pr-4 pt-4 text-start"
                    >
                      <div className="items-center justify-between text-xs text-gray-200">
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                        {{
                          asc: "",
                          desc: "",
                        }[header.column.getIsSorted() as string] ?? null}
                      </div>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>
          {tableData.length == 0 ? (
            <tbody>
              <tr>
                <td colSpan={columns.length} style={{ textAlign: "center" }}>
                  <h2 className="m-4" style={{ fontSize: "30px" }}>
                    No Results!
                  </h2>
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {table
                .getRowModel()
                .rows.slice(0, 10)
                .map((row) => {
                  // console.log("object row :>> ", row);
                  return (
                    <tr key={row.id}>
                      {row.getVisibleCells().map((cell) => {
                        return (
                          <td
                            key={cell.id}
                            className="min-w-[20%] border-white/0 py-3 pr-4 text-start"
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext()
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
            </tbody>
          )}
        </table>
      </div>
    </Card>
  );
}
export default ColumnsTableUsers;
